import React from 'react';
import { createRoot } from 'react-dom/client';
import './globals.scss';
import './styleguide.scss';
import App from './App';
import { SiteContentProvider } from './context/SiteContentContext';

const container = document.getElementById('app');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <SiteContentProvider>
      <App />
    </SiteContentProvider>
  </React.StrictMode>
);
